export default class GameModeGroup {
    constructor(list) {
        this.list = list
    }

    contains(mode) {
        return this.list.indexOf(mode) >= 0
    }
}
